import React from 'react';
import AskNewaSummaryCard from '../components/AskNewaSummaryCard';

export default function Overview({ showToast }) {
  // const [invoices, setInvoices] = React.useState([]);

  // React.useEffect(() => {
  //   let mounted = true;
  //   getInvoices().then(data => {
  //     if (!mounted) return;
  //     setInvoices(data);
  //     saveInvoicesToLocal(data);
  //   }).catch(() => {
  //     setInvoices(loadInvoicesFromLocal());
  //   });
  //   return () => mounted=false;
  // }, [showToast]);

  return (
    <>
      {/* AskNEWA AI Summary Card */}
      <AskNewaSummaryCard />

      <div className="row-split">
        <div className="half card">
          <div className="card-title">
            <span>Revenue & Cash Flow</span>
            <span className="chip">MRR · Runway</span>
          </div>
          <div className="kpi-row">
            <div className="kpi-pill">
              <div className="kpi-label">MRR</div>
              <div className="kpi-value">₹3.2M</div>
            </div>
            <div className="kpi-pill">
              <div className="kpi-label">Runway</div>
              <div className="kpi-value">9.4 months</div>
            </div>
            <div className="kpi-pill">
              <div className="kpi-label">Collections (week)</div>
              <div className="kpi-value">₹4.5L</div>
            </div>
          </div>
          <div className="chart-placeholder"></div>
        </div>
        <div className="half card">
          <div className="card-title">
            <span>Sales Pipeline</span>
            <span className="chip">Sales Closer AI Active</span>
          </div>
          <div className="chart-placeholder"></div>
        </div>
      </div>
      <div className="row-split">
        <div className="third card">
          <div className="card-title">Inventory Health</div>
          <div className="chart-placeholder"></div>
        </div>
        <div className="third card">
          <div className="card-title">People & Teams</div>
          <div className="kpi-row">
            <div className="kpi-pill">
              <div className="kpi-label">Employees</div>
              <div className="kpi-value">37</div>
            </div>
            <div className="kpi-pill">
              <div className="kpi-label">Engagement</div>
              <div className="kpi-value">7.9/10</div>
            </div>
          </div>
          <div className="chart-placeholder"></div>
        </div>
        <div className="third card">
          <div className="card-title">Campaigns</div>
          <div className="chart-placeholder"></div>
        </div>
      </div>
      <div className="row-split">
        <div className="half card">
          <div className="card-title">Today's Focus (Autonomy OS)</div>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-time">09:00</div>
              <div className="timeline-text">
                <span>Call 8 high-risk invoices</span>
                <span className="tag">Collections Optimizer</span>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-time">11:00</div>
              <div className="timeline-text">
                <span>Approve reorder for 3 SKUs</span>
                <span className="tag">Smart Inventory Planner</span>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-time">15:00</div>
              <div className="timeline-text">
                <span>Review 2 pending offers</span>
                <span className="tag">HR Pulse Agent</span>
              </div>
            </div>
          </div>
        </div>
        <div className="half card">
          <div className="card-title">
            <span>Autonomy Score & Agents</span>
            <span className="chip tag-green">72 / 100</span>
          </div>
          <div className="chart-placeholder"></div>
          <div className="kpi-row">
            <div className="kpi-pill">
              <div className="kpi-label">AI Agents Active</div>
              <div className="kpi-value">3</div>
            </div>
            <div className="kpi-pill">
              <div className="kpi-label">Recommended</div>
              <div className="kpi-value">1</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
